// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ChatButton_chatButtonContainer__lbr-o {
  position: fixed;
  bottom: 50px;
  right: 20px;
  display: flex;
  align-items: center;
  gap: 5px;
}

.ChatButton_chatButton__YmyQK {
  position: relative; /* Added so the notification badge is positioned relative to this button */
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
}

.ChatButton_chatIcon__d-a61 {
  width: 90px;
  height: 80px;
}

.ChatButton_notificationBadge__pZ9W6 {
  position: absolute;
  top: 5px;
  right: 5px;
  width: 10px;
  height: 10px;
  background-color: red;
  border-radius: 50%;
  animation: ChatButton_pulse__HhDgh 1s infinite;
}

@keyframes ChatButton_pulse__HhDgh {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.2);
    opacity: 0.7;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.ChatButton_minimizeButton__lIfLx {
  background: none;
  border: none;
  font-size: 20px;
  color: white;
  cursor: pointer;
  padding: 5px;
  margin-left: 5px;
}

.ChatButton_miniChatButton__Zd2CE {
  position: fixed;
  bottom: 50px;
  right: 20px;
  background-color: #4a90e2;
  color: white;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
}

.ChatButton_miniChatButton__Zd2CE:hover {
  background-color: #357ABD;
}
`, "",{"version":3,"sources":["webpack://./src/Chat/ChatButton.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB,EAAE,0EAA0E;EAC9F,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,8CAA4B;AAC9B;;AAEA;EACE;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,qBAAqB;IACrB,YAAY;EACd;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".chatButtonContainer {\n  position: fixed;\n  bottom: 50px;\n  right: 20px;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.chatButton {\n  position: relative; /* Added so the notification badge is positioned relative to this button */\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n}\n\n.chatIcon {\n  width: 90px;\n  height: 80px;\n}\n\n.notificationBadge {\n  position: absolute;\n  top: 5px;\n  right: 5px;\n  width: 10px;\n  height: 10px;\n  background-color: red;\n  border-radius: 50%;\n  animation: pulse 1s infinite;\n}\n\n@keyframes pulse {\n  0% {\n    transform: scale(1);\n    opacity: 1;\n  }\n  50% {\n    transform: scale(1.2);\n    opacity: 0.7;\n  }\n  100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n.minimizeButton {\n  background: none;\n  border: none;\n  font-size: 20px;\n  color: white;\n  cursor: pointer;\n  padding: 5px;\n  margin-left: 5px;\n}\n\n.miniChatButton {\n  position: fixed;\n  bottom: 50px;\n  right: 20px;\n  background-color: #4a90e2;\n  color: white;\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n  cursor: pointer;\n  transition: all 0.3s ease-in-out;\n}\n\n.miniChatButton:hover {\n  background-color: #357ABD;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chatButtonContainer": `ChatButton_chatButtonContainer__lbr-o`,
	"chatButton": `ChatButton_chatButton__YmyQK`,
	"chatIcon": `ChatButton_chatIcon__d-a61`,
	"notificationBadge": `ChatButton_notificationBadge__pZ9W6`,
	"pulse": `ChatButton_pulse__HhDgh`,
	"minimizeButton": `ChatButton_minimizeButton__lIfLx`,
	"miniChatButton": `ChatButton_miniChatButton__Zd2CE`
};
export default ___CSS_LOADER_EXPORT___;
